const commonReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default commonReducer;